<template>
  <div>
    <div class="form__input form__input--checkbox form__input--checkbox--bold"
         v-for="firstLevelItem in mailingLists"
         :key="firstLevelItem.id">

      <mailing-list-section :item="firstLevelItem"
                            @change="handleChange"
                            :data="data" />
    </div>
  </div>
</template>

<script>
import mailingListSection from './MailingListSection';
import formElement from '../mixins/form-element';

export default {
  mixins: [formElement],
  props: ['mailingLists', 'data'],
  components: { mailingListSection },
  methods: {
    handleChange(change) {
      this.$emit('change', change);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MailingListsColumn.vue